"use client";
import styled from "@emotion/styled";
import Image from "next/image";
import Link from "next/link";
// import wallet from "@/assets/img/icons/wallet.png";
import accountSettings from "@/assets/img/icons/user-gear-lg.png";
import dashboard from "@/assets/img/icons/dashboard.png";
import transaction from "@/assets/img/icons/transaction.png";

const MobileFooterMenuContainer = styled.div`
  display: none;

  @media (max-width: 991px) {
    display: flex;
  }

  position: fixed;
  bottom: -2px;
  left: 0;
  height: 65px;
  width: 100%;
  z-index: 1000;
  background: linear-gradient(
    180deg,
    var(--tg-secondary-color) 0%,
    rgba(34, 36, 56, 0.975) 100%
  );
  /* height: 90px; */
  border-top-right-radius: 50px;
  border-top-left-radius: 50px;
  border-top: 1px solid #44325e;

  a {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 10px;
    font-weight: 500;
    text-transform: uppercase;
    cursor: pointer;

    border-right: 1px solid #44325e;

    &:last-child {
      border-right: none;
    }
  }
`;

export const MobileFooterMenu = () => {
  return (
    <MobileFooterMenuContainer className="bg-slate-900 flex justify-between gap-2">
      <Link
        href="/dashboard"
        className="flex items-center justify-center p-2 gap-1 text-xs"
      >
        <Image className="size-4" src={dashboard} alt="logo" />
        <span>Dashboard</span>
      </Link>
      <Link
        href="/dashboard/trade"
        className="flex items-center justify-center p-2 pb-3 gap-1 text-xs"
      >
        <Image className="size-5" src={transaction} alt="logo" />
        Sell Crypto
      </Link>
      {/* <Link
        // href="/dashboard/wallet"
        href="/dashboard/wallet?type=Fiat"
        className="items-center justify-center p-2 gap-1 text-xs"
      >
        <Image src={wallet} className="size-4" alt="logo" />
        Wallet
      </Link> */}
      <Link
        href="/dashboard/account/settings"
        className="items-center justify-center p-2 gap-1 text-xs"
      >
        <Image src={accountSettings} className="size-4" alt="logo" />
        Account
      </Link>
      {/* <Link
        // href="/dashboard/wallet"
        href="/dashboard/wallet?type=Fiat"
        className="items-center justify-center p-2 gap-1 text-xs"
      >
        <Image src={wallet} className="size-4" alt="logo" />
        Wallet
      </Link> */}
    </MobileFooterMenuContainer>
  );
};
